import { DateTimeGroup, TextData } from "../styles";
import CalendarIcon from "icons/CalendarIcon";
import TimerIcon from "icons/TimerIcon";
import { getText as getTimeText } from "components/CustomTimePicker/utils";
import {
    getDateMonthString,
    getDatePartsByMillis,
    getDayOfDateByTimestamp
} from "components/CustomDatePicker/utils/helpers";
import { FieldIconWrapper } from "views/components/Schedules/styles";

const ReservationDurationData = ({
    duration: {
        date,
        timeParts
    },
    gap,
    color = "black"
}) => {
    function getFormattedTime() {
        return `${getTimeText(timeParts.start)} - ${getTimeText(timeParts.end)}`;
    }
    function getFormattedDate() {
        const [year, month, dateNumber] = getDatePartsByMillis(date);
        return `${getDayOfDateByTimestamp(date).substring(0, 3)}, ${getDateMonthString([month, dateNumber])} ${year}`;
    }
    return (
        <>
            <DateTimeGroup
                className={color}
                gap={gap}>
                <FieldIconWrapper>
                    <TimerIcon/>
                </FieldIconWrapper>
                <TextData>{getFormattedTime()}</TextData>
            </DateTimeGroup>
            <DateTimeGroup
                className={color}
                gap={gap}>
                <FieldIconWrapper>
                    <CalendarIcon/>
                </FieldIconWrapper>
                <TextData>{getFormattedDate()}</TextData>
            </DateTimeGroup>
        </>
    );
}

export default ReservationDurationData;